/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { ReportTrackerState } from "~/features/reportTracker/types";
import { RootState } from "~/state/types";

const getState = (state: RootState) => state.report;

const createSelector =
  <TSelected = unknown>(selector: (state: ReportTrackerState) => TSelected): ((rootState: RootState) => TSelected) =>
  (rootState) =>
    selector(getState(rootState));
export const selectIsReportTrackerOpen = createSelector((state) => state.isReportTrackerOpen);

export const selectShouldRefreshTracker = createSelector((state) => state.shouldRefreshTracker);

export const selectReportsData = createSelector((state) => state.reports.data);

export const selectSitesByName = createSelector((state) => state.sites);
